import React, { FC, Suspense, lazy } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { environment } from "@environment/environment";
import { CircularProgress } from "@mui/material";

const BlankPage = lazy(() => import("@components/blank-app"));

const SpecialGiveAwayApp = lazy(() => import("@components/special-giveaway"));

const PASpecialGiveAwayApp = lazy(
  () => import("@components/pa-koomsure-special-giveaway"),
);

const Loading = () => (
  <CircularProgress
    style={{ position: "absolute", top: "50%", left: "50%" }}
    size={64}
  />
);

const AppRoute: FC = () => {
  return (
    <BrowserRouter
      basename={environment.basePath.length ? environment.basePath : undefined}
    >
      <Suspense fallback={<Loading />}>
        <Routes>
          <Route path="/" element={<BlankPage />} />
          <Route
            path="/gentravelsafe-special-giveaway/"
            element={<SpecialGiveAwayApp />}
          />
          {/* <Route
            path="/pa-koomsure-special-giveaway/"
            element={<PASpecialGiveAwayApp />}
          /> */}
          <Route path="*" element={<BlankPage />} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
};

export default AppRoute;
